module.exports = __webpack_public_path__ + "static/media/led-turn-signal-zoom.6ca8aadb.png";